import { render, staticRenderFns } from "./InsuranceStatus.vue?vue&type=template&id=08d7af9a&scoped=true"
import script from "./InsuranceStatus.vue?vue&type=script&lang=js"
export * from "./InsuranceStatus.vue?vue&type=script&lang=js"
import style0 from "./InsuranceStatus.vue?vue&type=style&index=0&id=08d7af9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d7af9a",
  null
  
)

export default component.exports